import * as React from "react"

const CrossCircled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" {...props}>
    <path d="M2.5 8a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0ZM8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13ZM6.4 5.6a.5.5 0 1 0-.8.8L7.3 8 5.6 9.6a.5.5 0 0 0 .8.8L8 8.7l1.6 1.7a.5.5 0 0 0 .8-.8L8.7 8l1.7-1.6a.5.5 0 0 0-.8-.8L8 7.3 6.4 5.6Z" />
  </svg>
)

export default CrossCircled
